import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './PaymentNotSuccessful.css';
import { getAuth } from 'firebase/auth';
import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../utils/firebase'; // Ensure this points to your Firestore instance

function PaymentNotSuccessful() {
  const navigate = useNavigate();

  useEffect(() => {
    const resetDesiredPurchase = async () => {
      const auth = getAuth();
      const user = auth.currentUser; // Get current user

      if (user) {
        const userRef = doc(db, 'users', user.uid); // Reference to user's document in Firestore
        try {
          await updateDoc(userRef, {
            desiredPurchase: 0 // Resetting desiredPurchase
          });
          console.log('desiredPurchase reset successfully');
        } catch (error) {
          console.error('Error resetting desiredPurchase: ', error);
        }
      }
    };

    resetDesiredPurchase();
  }, []);

  const navigateTo = (path) => {
    navigate(path);
  };

  return (
    <div className="PNS-Menu-container">
      <h1 className="PNS-header-title">The iSpeakWell Project</h1>
      <h5 className="PNS-tagLine">
        Become a member of the iSpeakWell crew.
      </h5>
      <hr />
      <h1 className = "PNS-Task-Menu">Payment Incomplete</h1>
      <h3 className="PNS-Task-Menu">Your tokens have not been updated.</h3>
      <hr />
      <h2 className="PNS-Task-Menu">Select a task to continue</h2>
      <button className="PNS-primary-btn" onClick={() => navigateTo("/voicebot")}>The iSpeakWell Project</button>
      <div className="PNS-BTN-HLDR">
        <button className="PNS-secondary-btn" onClick={() => navigateTo("/resumerevisor")}>Resume and Cover Letter</button>
        <button className="PNS-secondary-btn" onClick={() => navigateTo("/interview-practice")}>Interview Practice</button>
        <button className="PNS-secondary-btn" onClick={() => navigateTo("/conversationpractice")}>Conversation Practice</button>
      </div>
      <button className="PNS-money-btn" onClick={() => navigateTo("/Purchase")}>Get Tokens</button>
    </div>
  );
}

export default PaymentNotSuccessful;
